module.exports = __webpack_public_path__ + "static/media/calendar.34889ae9.svg";